export function PingHandler(data: object, webchat: any) {
    console.debug('Received Ping event', data);
    webchat.sendMessage('', {
        pong: 'pong'
    });
}
